import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { AuthRedux, getCookie } from 'auth-advenio'
import { MsalContext } from "@azure/msal-react"
import { ChatWidget } from 'advenio-chat-ia'
import Navbar from '../../Components/ParentPlatform/Navbar'
import ChildButton from '../../Components/ParentPlatform/Navbar/ChildButton'
import { Colors } from 'advenio-components'
import { API_DOMAIN } from '../../config'
import { gb, featuresReady, setGrowthBookUser } from '../../utils/growthbook'
import { isNil } from 'ramda'

import ChildrenActions, { Selectors } from '../../Data/Redux/ParentPlatform/ChildrenRedux'
import RatingActions from '../../Data/Redux/ParentPlatform/RatingRedux'

import { stripEmptyValues, parseFullName } from '../../utils/Utils'

const ChildrenList = styled.div`
  width: 100%;
  overflow: auto;
  max-height: 256px;
  background-color: #F3F3F3;
  overflow-x: hidden;
`
const MobileContainer = styled.div`
  display: block;
  @media (min-width:768px) {
    display: none;
  }
`
const DesktopContainer = styled.div`
  display: none;
  @media (min-width:768px) {
    display: block;
  }
`
const KidDrawerButton = styled.div`
  height: 64px;
  width: 100%;
  background-color:${({ active,enroll }) => enroll && active ? Colors.red700 : enroll ? Colors.red600 : active ? '#6c768a' : '#454C59'};
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
     filter: brightness(85%);
  }
`
const KidDrawerInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  span:first-of-type{
    font-size: 16px;
    font-weight: bold;
  }
  span:last-of-type{
    font-size: 10px;
    filter: brightness(90%);
  }
`

const KidPhoto = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 20px;
  margin: 8px;
`


const LogOut = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
  color: rgba(0,0,0,.7);
  cursor: pointer;

  @media (min-width: 768px) {
    color: rgba(249,249,251,.6);
    background-color:#454C59;
  }

  img{
    margin:4px 4px 4px 0;
  }

  &:hover {
     filter: brightness(85%);
  }
`
const SlotContainer = styled.div`
  overflow: hidden;
  @media (min-width:768px) {
    margin-left: 220px;
    margin-top: 64px;
  }
  @media (min-width:1024px) {
    margin-left: 280px;
    margin-top: 64px;
  }
`

class ParentLayout extends Component {

  constructor(props){
    super(props)
    this.state = {
      chatIaEnabled:false
    }
  }

  static contextType = MsalContext

  componentDidMount = () => {
    const { user } = this.props

    // GrowthBook: setear atributos del padre para targeting
    if (user) {
      setGrowthBookUser(user).then(() => {
        this.updateGrowthBookFeatures()
      })
    }

    // Suscribirse a cambios de features (streaming/refresh)
    this._gbUnsubscribe = gb.subscribe(() => {
      this.updateGrowthBookFeatures()
    })

    // Esperar carga inicial de features
    featuresReady.then(() => {
      this.updateGrowthBookFeatures()
    })

    this.props.getChildren(user.id)
  }

  componentWillUnmount() {
    if (typeof this._gbUnsubscribe === "function") {
      this._gbUnsubscribe()
    }
  }

  updateGrowthBookFeatures = () => {
    var chatIaValue = gb.getFeatureValue("chat-ia", null)
    if (!isNil(chatIaValue)) {
      this.setState({ chatIaEnabled: chatIaValue.enabled || false })
    } else {
      this.setState({ chatIaEnabled: false })
    }
  }

  onChildClick = (e) => {
    const { getProfile, getRating, getStudentActivitiesViaParent } = this.props
    this.props.setActiveChild(Number(e.currentTarget.id))
    getProfile(Number(e.currentTarget.id))
    getRating(Number(e.currentTarget.id))
    getStudentActivitiesViaParent(Number(e.currentTarget.id))
    this.nav.close()
  }

  logout = () => {
    if(this.context.accounts.length > 0){
      this.context.instance.logoutPopup({
        postLogoutRedirectUri: "/",
        // mainWindowRedirectUri:"/login"
      }).then(()=> this.props.logout())
    }
    else{
      this.props.logout()
    }  }

  render() {
    const { children } = this.props
    const { chatIaEnabled } = this.state
    console.log(chatIaEnabled)
    return (
      <div>
        <Navbar ref={(nav) => { this.nav = nav }}>
          <DesktopContainer>
            <ChildrenList>
              {children && children.map(child => (
                <KidDrawerButton
                  key={child.id}
                  active={child.id === this.props.activeChildId}
                  enroll={!! child.deleted_at}
                  id={child.id}
                  onClick={this.onChildClick}
                >
                  <KidPhoto src={child.profile_pictures ? child.profile_pictures['thumb-sm'] : '/assets/BabyAvatar.svg'} />
                  <KidDrawerInfo>
                    <span>{`${child.first_name} ${child.last_name_paternal}`}</span>
                    <span>{`${child.classroom}`}{ !!child.deleted_at &&(' - Baja')}</span>
                    <span>Centro - { child.center.name}</span>
                  </KidDrawerInfo>
                </KidDrawerButton>
              ))}
            </ChildrenList>
            <LogOut onClick={this.logout}>
              <img src="/assets/Checkin.svg" alt="log out" />
              Cerrar sesion
            </LogOut>
          </DesktopContainer>
          <MobileContainer>
            <ChildrenList>
              {children && children.map(child => (
                <ChildButton
                  {...child}
                  key={child.id}
                  name={parseFullName(child)}
                  context={stripEmptyValues`${child.center.name} ${child.study_program}`}
                  active={child.id === this.props.activeChildId}
                  onClick={this.onChildClick}
                  id={child.id}
                />
              ))}
            </ChildrenList>
            <LogOut onClick={this.logout}>
              <img src="/assets/Checkin.svg" alt="log out" />
              Cerrar sesion
            </LogOut>
          </MobileContainer>
        </Navbar>
        <SlotContainer>
          {this.props.slot}
        </SlotContainer>
        <ChatWidget
          apiBaseUrl={API_DOMAIN}
          apiPath="/miadvenio/chat/conversations"
          token={getCookie('advenio_api_key') || ''}
          enabled={chatIaEnabled}
          welcomeTitle="¡Hola! Soy Veni"
          welcomeText="Tu asistente de MiAdvenio. Puedo ayudarte con tips sobre el cuidado de tu bebé, información del centro y resolver tus dudas."
          suggestions={['Tips para mi bebé', 'Políticas del centro', 'Desarrollo de mi hijo']}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  children: state.parent_platform_children.get.results,
  loading: state.parent_platform_children.get.fetching,
  activeChildId: state.parent_platform_children.activeChildId,
  activeChild: Selectors.activeChild(state),
})

const mapDispatchToProps = dispatch => ({
  getProfile: childId => dispatch(ChildrenActions.getProfileRequest(childId)),
  getStudentActivitiesViaParent: (studentId, query) =>
  dispatch(ChildrenActions.getActivitiesRequest(studentId, query)),
  getRating: studentId => dispatch(RatingActions.getRequest(studentId,true)),
  setActiveChild: id => dispatch(ChildrenActions.setActiveChildId(id)),
  getChildren: parentId => dispatch(ChildrenActions.getRequest(parentId)),
  logout: () => dispatch(AuthRedux.Actions.logout({ shouldDeleteCookies: true })),
})

export default connect(mapStateToProps, mapDispatchToProps)(ParentLayout)



// WEBPACK FOOTER //
// ./src/Containers/ParentPlatform/ParentLayout.jsx